"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
var Modal_1 = require("../components/Modals/Modal");
function useModal(Title, Subtitle, Content, ZIndex, CleanUp) {
    var _a = react_1.useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var _b = react_1.useState({ title: "", subtitle: "", content: null, cleanUp: function () { }, zIndex: 100 }), params = _b[0], setParams = _b[1];
    function formModal(title, subtitle, content, zIndex, cleanUp) {
        if (zIndex === void 0) { zIndex = 100; }
        var params = { title: title, subtitle: subtitle, content: content, zIndex: zIndex, cleanUp: cleanUp || (function () { }) };
        setParams(params);
        setIsOpen(true);
    }
    var title = params.title, subtitle = params.subtitle, content = params.content, cleanUp = params.cleanUp, zIndex = params.zIndex;
    var element = React.createElement(Modal_1.default, { isOpen: isOpen, setIsOpen: setIsOpen, title: title, subtitle: subtitle, content: content || null, cleanUp: cleanUp, zIndex: zIndex });
    return [element, setIsOpen, formModal];
}
exports.default = useModal;
//# sourceMappingURL=useModal.js.map